/**
 * @desc 分页
 */
const URL = "/rantion-fulfilment";
import http, { updateResponse } from "@/http";
export function request(params: API.fulfilment.warehouseMaster.page.Params, options?: any) {
  return updateResponse(
    http(URL + `/fulfilment/warehouseMaster/page`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
